<template>
  <div class="container">
    <div class="card-panel center-align">
      Gold: {{ presentValue.gold }}
      &nbsp;/ Silver: {{ presentValue.silver }}
      <br />
      <!-- <RangeSlider /> -->
    </div>
    <div
      class="card-panel center-align"
      v-if="isUsingDefaultValue.gold || isUsingDefaultValue.silver"
    >
      <div v-if="isUsingDefaultValue.gold">
        The API was unable to fetch the current gold price so we are instead
        using a default value of ${{ defaultValueGold }} to provide an
        approximate worth of assets.
      </div>
      <div v-if="isUsingDefaultValue.silver">
        The API was unable to fetch the current silver price so we are instead
        using a default value of ${{ defaultValueSilver }} to provide an
        approximate worth of assets.
      </div>
    </div>
    <div class="card-panel center-align flow-text">
      You have stacked
      <span>{{ totalQuantity(assets, "gold") }}</span>
      oz of Gold and <span>{{ totalQuantity(assets, "silver") }}</span> oz of Silver. It cost you
      ${{ totalCostCorrectlyFormatted(assets) }} to accumulate.
      <div v-show="calculatePresentValue(assets) > 0">
        The current spot worth of your assets is
        <strong>${{ totalPresentValueCorrectlyFormatted(assets) }}</strong>
        Canadian Dollars.
        <div class="profit-panel" v-html="profitPercentage(assets)"></div>
      </div>
      <div v-show="calculatePresentValue(assets) > 0">
        On average, you bought Gold for ${{ averageBullionPrice(assets)[0] }}/oz
        and Silver for ${{ averageBullionPrice(assets)[1] }}/oz in Canadian
        dollars.
      </div>
      <div v-if="calculatePresentValue(assets) === 0" class="add-button">
        <router-link
          class="waves-effect waves-light btn-large amber darken-4"
          :to="{ name: 'AddAssets' }"
        >Add Assets</router-link>
      </div>
      <p>
        Save this link to anonymously edit your assets in the future:
        <br />
        <strong
          class="yellow darken-4 permanent-path"
          @click="copyToClipboard(permanent_path)"
        >{{ permanent_path }}</strong>
      </p>
    </div>
    <div class="index">
      <div class="card" v-for="asset in assets" :key="asset.id">
        <div class="right-align">
          <i class="material-icons delete" @click="deleteAsset(asset.id)">delete</i>
        </div>
        <div class="card-image waves-effect waves-block waves-light">
          <img class="activator" :src="imgSrc(asset)" :alt="[asset]" />
        </div>
        <div class="card-stacked">
          <div class="card-content">
            <p>{{ content(asset) }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import db from "@/firebase/init";
import helpers from "@/helpers/helpers";

import RangeSlider from "@/components/RangeSlider";

export default {
  components: {
    RangeSlider
  },
  name: "ViewAssets",
  data() {
    return {
      user_id: this.$route.params.user_id,
      permanent_path: `https://stacker-tracker.firebaseapp.com${this.$route.path}`,
      presentValue: {
        gold: 0,
        silver: 0
      },
      isUsingDefaultValue: {
        gold: false,
        silver: false
      },
      isExampleUser: false,
      assets: [],
      asset_types: {
        GOLD: "gold",
        SILVER: "silver"
      }
    };
  },
  methods: {
    copyToClipboard(str) {
      const el = document.createElement("textarea");
      el.value = str;
      el.setAttribute("readonly", "");
      el.style.position = "absolute";
      el.style.left = "-9999px";
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);

      this.$alertify.success("Link has been copied.");
    },
    updateID() {
      this.user_id = this.$route.params.user_id;
      this.permanent_path = this.$route.params.path;
    },
    imgSrc(asset) {
      let image = require.context("../assets/", false, /\.png$/);
      return image(`./${asset.asset_class}-${asset.type}.png`);
    },
    content(asset) {
      let s = asset.quantity > 1 ? "s were" : " was";
      let type_str = `${helpers.ucfirst(asset.asset_class)} ${asset.type}${s}`;

      return `${asset.quantity} oz of ${type_str} bought for $${
        asset.price
      } on ${this.formattedDate(asset.date_recorded)}.`;
    },
    formattedDate: dt => moment.unix(dt).format("Do MMM, YYYY"),
    totalQuantity(assets, type) {
      return assets.reduce((accumulator, asset) => {
        let quantity = 0;
        if (asset.asset_class === type) {
          quantity = parseFloat(asset.quantity);
        }                
        return accumulator + quantity;
      }, 0);
    },
    totalCost(assets, type) {
      return assets.reduce((accumulator, asset) => {          
        return accumulator + asset.quantity * parseFloat(asset.price);
      }, 0);
    },
    // getAssetQuantity (assets) {
    //   let totalGoldQuantity = 0;
    //   let totalSilverQuantity = 0;

    //   assets.forEach(asset => {
    //     if (asset.asset_class == this.asset_types.GOLD) {
    //       totalGoldQuantity += parseFloat(asset.quantity);
    //     } else if (asset.asset_class == this.asset_types.SILVER) {
    //       totalSilverPrice +=
    //         parseFloat(asset.quantity) * parseFloat(asset.price);
    //       totalSilverQuantity += parseFloat(asset.quantity);
    //     }
    //   });
    // },
    averageBullionPrice(assets) {
      let totalGoldPrice = 0;
      let totalSilverPrice = 0;

      let totalGoldQuantity = 0;
      let totalSilverQuantity = 0;

      assets.forEach(asset => {
        if (asset.asset_class == this.asset_types.GOLD) {
          totalGoldPrice +=
            parseFloat(asset.quantity) * parseFloat(asset.price);
          totalGoldQuantity += parseFloat(asset.quantity);
        } else if (asset.asset_class == this.asset_types.SILVER) {
          totalSilverPrice +=
            parseFloat(asset.quantity) * parseFloat(asset.price);
          totalSilverQuantity += parseFloat(asset.quantity);
        }
      });

      return [
        (totalGoldPrice / totalGoldQuantity).toFixed(2),
        (totalSilverPrice / totalSilverQuantity).toFixed(2),
        totalGoldQuantity,
        totalSilverQuantity
      ];
    },
    totalCostCorrectlyFormatted(assets) {
      const totalCost = this.totalCost(assets);
      return helpers.numberWithCommas(totalCost);
    },
    totalPresentValueCorrectlyFormatted(assets) {
      const totalPresentValue = this.calculatePresentValue(assets);
      return helpers.numberWithCommas(totalPresentValue.toFixed(2));
    },
    async fetchBullionAPI() {
      // https://service.nfusionsolutions.biz/api/Metals/HistoricalSpots?token=fde04ee5-babb-43ca-a845-32b06d1ceb42&rd=false&metals=gold&currency=CAD&historicalfx=true&start=2018-12-13&end=2018-12-13
      // const dateToday = moment()
      //   .subtract(1, "day")
      //   .format("YYYY-MM-DD");
      // const token = "fde04ee5-babb-43ca-a845-32b06d1ceb42";
      // const currency = "CAD";
      // const goldReq = await axios.get(
      //   "https://service.nfusionsolutions.biz/api/Metals/HistoricalSpots",
      //   {
      //     params: {
      //       start: dateToday,
      //       end: dateToday,
      //       token,
      //       rd: "false",
      //       metals: this.asset_types.GOLD,
      //       currency,
      //       historicalfx: "false"
      //     }
      //   }
      // );
      // const silverReq = await axios.get(
      //   "https://service.nfusionsolutions.biz/api/Metals/HistoricalSpots",
      //   {
      //     params: {
      //       start: dateToday,
      //       end: dateToday,
      //       token,
      //       rd: "false",
      //       metals: this.asset_types.SILVER,
      //       currency,
      //       historicalfx: "false"
      //     }
      //   }
      // );

      const url = `https://metals-api.com/api/latest`;      
      const access_key = `85l44s69oxkjfa0jnz4p2141k051ikumh88hkidcq7izpam6tl0890br25g9`;
      const base = `CAD`;
      const symbols = `XAU,XAG`;

      const response = await axios.get(
        url,
        {
          params: {
            access_key,
            base,
            symbols            
          }
        }
      );
      
      return response.data;
    },
    async getBullionPrices() {
      // const [goldReq, silverReq] = await this.fetchBullionAPI();

      // const goldJson = JSON.parse(goldReq.request.response);
      // const silverJson = JSON.parse(silverReq.request.response);

      //const metalsJSON = JSON.parse(`{"success":true,"timestamp":1646758680,"date":"2022-03-08","base":"CAD","rates":{"XAG":33.94535537829025,"XAU":2653.291501324982},"unit":"per ounce"}`);
      
      const bullion = await this.fetchBullionAPI();
      
      // let goldPrice = goldJson[0].data.intervals[0].last;
      // let silverPrice = silverJson[0].data.intervals[0].last;

      let goldPrice = bullion.rates.XAU.toFixed (2);
      let silverPrice = bullion.rates.XAG.toFixed (2);
          
      // Resort to default values for gold and silver if none can be found
      if (goldPrice < 1) {
        self.isUsingDefaultValue.gold = true;
      } else if (silverPrice < 1) {
        self.isUsingDefaultValue.silver = true;
      }

      this.presentValue.gold = goldPrice;
      this.presentValue.silver = silverPrice;
    },
    calculatePresentValue(assets) {
      return assets.reduce((accumulator, asset) => {
        let presentPrice;
        if (asset.asset_class === this.asset_types.GOLD) {
          presentPrice = this.presentValue.gold;
        } else if (asset.asset_class === this.asset_types.SILVER) {
          presentPrice = this.presentValue.silver;
        }
        return (
          accumulator + parseFloat(asset.quantity) * parseFloat(presentPrice)
        );
      }, 0);
    },
    profitPercentage(assets) {
      const totalCost = this.totalCost(assets);
      const presentValue = this.calculatePresentValue(assets);

      const totalProfit = (presentValue - totalCost).toFixed(2);
      const grossMargin = (
        (100 * (presentValue - totalCost)) /
        presentValue
      ).toFixed(2);

      const desc = totalProfit > 0 ? "profit" : "loss";

      return `You had a total ${desc} of <span class='${desc}'>$${totalProfit}</span> with a <span class='${desc}'>${grossMargin}%</span> gross margin.`;
    },
    deleteAsset(id) {
      if (!this.isExampleUser) {
        db.collection("assets")
          .doc(id)
          .delete()
          .then(() => {
            // remove it from the assets array
            this.assets = this.assets.filter(asset => {
              return asset.id != id;
            });
          });
      } else {
        this.$alertify.alertWithTitle(
          "Sorry",
          "This is an example so delete mode is turned off."
        );
      }
    }
  },
  watch: {
    $route: "updateID"
  },
  beforeCreate() {
    // get the last recorded default value for gold and silver
    db.collection("bullion_prices")
      .orderBy("date_recorded", "desc")
      .limit(1)
      .get()
      .then(snapshot => {
        snapshot.forEach(doc => {
          if (this.presentValue.gold == 0 || this.presentValue.silver == 0) {            
            this.presentValue.gold = doc.data().gold_price;
            this.presentValue.silver = doc.data().silver_price;            
          }
        });
      });
  },
  created() {
    this.getBullionPrices();

    if (this.user_id === "ZgU6g0zy") {
      this.isExampleUser = true;
    }

    db.collection("assets")
      .where("id", "==", this.user_id)
      .orderBy("date_recorded", "desc")
      .get()
      .then(snapshot => {
        snapshot.forEach(doc => {
          let asset = doc.data();
          asset.id = doc.id;
          this.assets.push(asset);
        });
      });
  },
  beforeDestroy() {
    if (this.presentValue.gold > 0 && this.presentValue.silver > 0) {
      // save the present value of bullion in firebase
      db.collection("bullion_prices").add({
        gold_price: this.presentValue.gold,
        silver_price: this.presentValue.silver,
        date_recorded: moment().unix()
      });
    }
  }
};
</script>

<style>
.index {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-gap: 30px;
  margin-top: 20px;
}
.index h2 {
  font-size: 1.8em;
  margin-top: 0px;
}
.index .card img {
  padding: 10px;
  cursor: default;
}
.index .delete {
  cursor: pointer;
  color: #aaa;
  font-size: 1.4em;
}
.container .card-panel {
  margin-top: 20px;
}
.container .card-panel .add-button {
  margin-top: 10px;
}
.permanent-path {
  cursor: pointer;
  color: #ffffff;
  padding: 3px;
  border-radius: 3px;
}
.profit-panel {
  margin-top: 25px;
}
.profit,
.loss {
  font-weight: bold;
}
.profit {
  color: forestgreen;
}
.loss {
  color: red;
}
@media screen and (max-width: 992px) {
  .index {
    grid-template-columns: 1fr 1fr;
  }
}

@media screen and (max-width: 600px) {
  .permanent-path {
    white-space: pre-wrap; /* css-3 */
    white-space: -moz-pre-wrap; /* Mozilla, since 1999 */
    white-space: -pre-wrap; /* Opera 4-6 */
    white-space: -o-pre-wrap; /* Opera 7 */
    word-wrap: break-word; /* Internet Explorer 5.5+ */
  }
  .index {
    grid-template-columns: 1fr;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ViewAssets.vue